<div>
  <input pInputText id="on_label" [ngModel]="scientificName" autocomplete="off" readonly disabled />
  <p-button icon="pi pi-search" text="true" [style]="{ height: '100%' }" (click)="modalShow()" data-testid="taxonSearch" />
  <p-button
    icon="fa fa-times"
    severity="danger"
    text="true"
    [style]="{ height: '100%' }"
    (click)="clearTaxon()"
    [disabled]="selectedTaxon === null"
    data-testid="taxonClear" />
</div>

<p-dialog
  [closable]="false"
  [closeOnEscape]="false"
  [modal]="true"
  [position]="'center'"
  [style]="{ width: '800px' }"
  [visible]="dialogVars.visible"
  data-testid="dlgTaxonSearch"
  appendTo="body">
  <ng-template #header>
    <h6>Taxonomy Search</h6>
  </ng-template>

  <div class="flex flex-row gap-2 mt-1">
    <p-floatlabel variant="on">
      <label for="on_label">Scientific Name</label>
      <input
        pInputText
        id="search"
        [(ngModel)]="searchArgs.name"
        autocomplete="off"
        (keyup.enter)="searchTaxonClick()"
        data-testid="taxonSearchTerm" />
    </p-floatlabel>
    <p-floatlabel variant="on">
      <p-select
        [(ngModel)]="searchArgs.matchType"
        inputId="matchType"
        [options]="matchTypes"
        optionLabel="name"
        data-testid="optionsMatchTypes"
        appendTo="body"></p-select>
      <label for="matchType">Match Types</label>
    </p-floatlabel>
    <p-button
      label="Search"
      icon="pi pi-search"
      class="mr-1"
      pTooltip="Search Taxonomy"
      tooltipPosition="top"
      (click)="searchTaxonClick()"
      [disabled]="!isSearchValid()"
      data-testid="btnSearchTaxonomy"></p-button>
  </div>

  <ng-container *ngIf="dialogVars.displayData">
    <p-table
      [value]="dialogVars.displayData"
      [autoLayout]="true"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [paginator]="true"
      currentPageReportTemplate="{first} to {last} of {totalRecords} records"
      [pageLinks]="3"
      [lazy]="true"
      (onLazyLoad)="handleGridEvent($event)"
      [totalRecords]="dialogVars.response.pagination.totalCount"
      appendTo="body"
      [filterDelay]="0"
      [globalFilterFields]="['scientificName', 'division', 'rank']"
      styleClass="p-datatable-sm p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Scientific Name</th>
          <th>Division</th>
          <th>Rank</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-taxon>
        <tr>
          <td class="pt-1 pb-1 m-0 middle">
            <div class="flex">
              <div class="pr-1">
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-plus-circle"
                  class="p-button-rounded p-button-success p-button-text"
                  pTooltip="Select Taxonomy"
                  tooltipPosition="top"
                  (click)="selectTaxon(taxon)"
                  [disabled]="!pageVars.isReady"
                  attr.data-testid="dlgSelectTaxonomyButton{{ taxon.id }}"></button>
              </div>
            </div>
          </td>
          <td class="pt-1 pb-1 middle" attr.data-testid="tdScientificName{{ taxon.scientificName }}">
            {{ taxon.scientificName }}
          </td>
          <td class="pt-1 pb-1 middle" attr.data-testid="tdDivision{{ taxon.division }}">
            {{ taxon.division }}
          </td>
          <td class="pt-1 pb-1 middle" attr.data-testid="tdRank{{ taxon.rank }}">
            {{ taxon.rank }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No results.</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <ng-template #footer class="flex justify-content-start gap-2">
    <div class="flex">
      <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="modalExit()" data-testid="taxonCancel" />
    </div>
  </ng-template>
</p-dialog>

<app-processing [visible]="!pageVars.isReady"></app-processing>
